import {
  CommonStatus,
  StepInfoStatus,
  TableSessionStatus,
  UserPlan,
} from "../constants/enum";
import Countdown, { CountdownApi, zeroPad } from "react-countdown";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { updateTableSession, updateTableTime } from "../api/tableSession";
import { useMutation, useQuery, useQueryClient } from "react-query";

import Cookies from "js-cookie";
import { IStepInfo } from "constants/interface";
import ModalConfirm from "./Modal/ModalConfirm";
import _ from "lodash";
import moment from "moment";
import { queryKeys } from "../constants/constans";
import useNetworkStatus from "hooks/useNetworkStatus";

const shouldComponentUpdate = (prevProps: any, nextProps: any) => {
  // Return true nếu KHÔNG cần render lại
  return (
    prevProps.infoTable?.lastUpdate === nextProps.infoTable?.lastUpdate &&
    prevProps.timer === nextProps.timer &&
    prevProps.intervalTime === nextProps.intervalTime &&
    prevProps.step === nextProps.step &&
    prevProps.overtime === nextProps.overtime
  );
};

export const CountdownComponent = React.memo((props: any) => {
  const {
    timer,
    setSeatingListIndex,
    intervalTime,
    infoTable,
    handleSetOverTime,
    handleSetLostTime,
    step,
    overtime,
    isLoading,
  } = props;

  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [showModalNextConfirm, setShowModalNextConfirm] =
    useState<boolean>(false);

  const dateNow = useRef(moment().valueOf());
  const hasAutoNextStep = useRef<boolean>(false);

  const refCountDown = useRef<CountdownApi | null>(null);
  const [countTime, setCountTime] = useState<number>(
    Number(timer) * 60 + Number(intervalTime) * 60
  );
  const countTimeTick = useRef<number>(
    Number(timer) * 60 + Number(intervalTime) * 60
  );
  const lastStop = useRef<string>(moment().toISOString());

  const [countTimeUpdate, setCountTimeUpdate] = useState<number>(
    Number(timer) * 60 + Number(intervalTime) * 60
  );
  const isFirstRender = useRef<boolean>(false); //ネクストを押すまでに何秒かカウント
  const isOnline = useNetworkStatus();
  const queryClient = useQueryClient();

  const updateTableSessionAction = useMutation(updateTableSession);
  const updateTableTimeAction = useMutation(updateTableTime);

  const userPlan = Cookies.get("userPlan");

  const defaultConfig = queryClient.getQueryData(queryKeys.defaultConfigTable);

  const [isAutoStepping, setIsAutoStepping] = useState<boolean>(false);

  useEffect(() => {
    if (
      [TableSessionStatus.Starting, TableSessionStatus.Stop].includes(
        infoTable?.status
      ) &&
      Array.isArray(infoTable?.stepInfos) &&
      infoTable
    ) {
      const currentInfo = infoTable?.stepInfos?.find(
        (item: any) => item.step === infoTable?.step
      );
      if (currentInfo) {
        setCountTime(currentInfo?.time);
        setCountTimeUpdate(currentInfo?.time);
        if (currentInfo?.time < 0) {
          handleSetOverTime();
        }
        countTimeTick.current = currentInfo?.time;
        dateNow.current = Date.now();
      } else {
        setCountTime(Number(timer) * 60 + Number(intervalTime) * 60);
        setCountTimeUpdate(Number(timer) * 60 + Number(intervalTime) * 60);
        countTimeTick.current = Number(timer) * 60 + Number(intervalTime) * 60;
        dateNow.current = Date.now();
      }

      if (
        !isFirstRender.current &&
        infoTable?.status === TableSessionStatus.Starting
      ) {
        isFirstRender.current = true;
        refCountDown.current?.start();
        lastStop.current = infoTable?.lastStop;
        dateNow.current = Date.now();
        setIsRunning(true);
      }
    }
    if (infoTable?.status === TableSessionStatus.NotStart) {
      setCountTime(Number(timer) * 60 + Number(intervalTime) * 60);
      setCountTimeUpdate(Number(timer) * 60 + Number(intervalTime) * 60);
      dateNow.current = Date.now();
      countTimeTick.current = Number(timer) * 60 + Number(intervalTime) * 60;
    }
  }, [infoTable?.status, infoTable?.step, step]);

  useEffect(() => {
    if (infoTable?.status === TableSessionStatus.Starting) {
      refCountDown.current?.start();
      // lastStop.current = infoTable?.lastStop;
      setIsRunning(true);
    }
    if (infoTable?.status === TableSessionStatus.Stop) {
      refCountDown.current?.pause();
      setIsRunning(false);
    }
  }, [infoTable?.status]);

  useEffect(() => {
    // Function to fetch data from the API
    if (isLoading) return;

    const updateData = async () => {
      if (infoTable?.status === TableSessionStatus?.NotStart) {
        return;
      }
      if (
        isRunning &&
        countTimeUpdate % 5 === 0 &&
        countTimeUpdate !== Number(timer) * 60 + Number(intervalTime) * 60
      ) {
        const timeRun = Math.floor(
          (moment().valueOf() - dateNow.current) / 1000
        );

        updateTableTimeAction.mutate(
          {
            id: infoTable?._id,
            data: {
              time: countTime - timeRun,
              step,
            },
          },
          {
            onError: (err) => {
              if (!!isOnline) {
                return;
              }
              const exitsStepInfo = infoTable?.stepInfos?.find(
                (item: any) => item.step === infoTable.step
              );
              let stepUpdated = infoTable.stepInfos;
              const time = countTime - timeRun;
              if (!exitsStepInfo) {
                stepUpdated.push({
                  step: infoTable.step,
                  time: countTime - timeRun,
                  status: StepInfoStatus.Running,
                });
              } else {
                stepUpdated = infoTable.stepInfos.map((step: IStepInfo) => {
                  if (
                    step.status === StepInfoStatus.Running &&
                    infoTable.step === step.step &&
                    time < step.time &&
                    time != step.time
                  ) {
                    return {
                      ...step,
                      time: time,
                    };
                  }
                  return step;
                });
              }
              const listTableSessionCurrent = queryClient.getQueryData(
                queryKeys.listTableSession
              ) as any;
              if (Array.isArray(listTableSessionCurrent?.data)) {
                const listTableSessionNew = listTableSessionCurrent?.data?.map(
                  (item: any) => {
                    if (String(item?._id) === String(infoTable?._id)) {
                      return {
                        ...item,
                        stepInfos: stepUpdated,
                      };
                    }
                    return item;
                  }
                );
                queryClient.setQueryData(queryKeys.listTableSession, {
                  data: listTableSessionNew,
                });
              }
            },
          }
        );
      }
    };

    // Call the fetchData function immediately
    updateData();
    // setTimeout(()=>)
    // Set up the interval to call fetchData every 5 seconds
    const intervalId = setInterval(updateData, 5000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [isRunning, countTimeUpdate, step, countTime, isAutoStepping, isLoading]);

  useEffect(() => {
    // Function to fetch data from the API

    const updateTimeLine = async () => {
      if (infoTable?.status === TableSessionStatus?.NotStart) {
        return;
      }
      let timeLineInfoReal = infoTable.timeLineInfoReal;
      const differTimeSecond = moment().diff(
        moment(timeLineInfoReal?.[infoTable?.step + 1], "HH:mm"),
        "second"
      );
      if (differTimeSecond >= 60) {
        timeLineInfoReal = timeLineInfoReal.map((item: any, index: number) => {
          if (index > infoTable?.step) {
            return moment(item, "HH:mm")
              .add(Math.floor(differTimeSecond / 60), "m")
              .format("HH:mm");
          }
          return item;
        });
        updateTableSessionAction.mutate(
          {
            id: infoTable?._id,
            data: {
              timeLineInfoReal,
            },
          },
          {
            onError: (err) => {
              if (!!isOnline) {
                return;
              }
              const listTableSessionCurrent = queryClient.getQueryData(
                queryKeys.listTableSession
              ) as any;
              if (Array.isArray(listTableSessionCurrent?.data)) {
                const listTableSessionNew = listTableSessionCurrent?.data?.map(
                  (item: any) => {
                    if (String(item?._id) === String(infoTable?._id)) {
                      return {
                        ...item,
                        timeLineInfoReal: timeLineInfoReal,
                      };
                    }
                    return item;
                  }
                );
                queryClient.setQueryData(queryKeys.listTableSession, {
                  data: listTableSessionNew,
                });
              }
            },
          }
        );
      }
    };

    // Call the fetchData function immediately
    updateTimeLine();
    // setTimeout(()=>)
    // Set up the interval to call fetchData every 5 seconds
    const intervalId = setInterval(updateTimeLine, 60000);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [moment().minutes(), infoTable?.step]);

  useEffect(() => {
    const timeRun = Math.floor((moment().valueOf() - dateNow.current) / 1000);
    const timeNotDone = countTime - timeRun;
    if (timeNotDone < 0) {
      handleSetOverTime();
    }
    if (
      !!handleSetLostTime &&
      timeNotDone > 0 &&
      timeNotDone <= Number(intervalTime) * 60
    ) {
      handleSetLostTime();
    }
  }, [countTime, countTimeUpdate]);

  const onClickNext = (isConfirm?: boolean) => {
    if (infoTable?.status === TableSessionStatus.NotStart) return;
    if (!!(defaultConfig as any)?.data?.showNextConfirm && !isConfirm) {
      setShowModalNextConfirm(true);
      return;
    }
    setShowModalNextConfirm(false);
    setSeatingListIndex(countTimeUpdate);

    // setIsRunning(true);
    setCountTime(Number(timer) * 60 + Number(intervalTime) * 60);
    setCountTimeUpdate(Number(timer) * 60 + Number(intervalTime) * 60);
    dateNow.current = Date.now();
    countTimeTick.current = Number(timer) * 60 + Number(intervalTime) * 60;
    hasAutoNextStep.current = false;
  };

  //次の時間の計算
  const calcNextTime = (
    startTime: string,
    intervalTime: number, //分
    timer: number //分
  ) => {
    const wd = "2000/01/01";
    const startDate = new Date(`${wd} ${startTime}`);
    const temp = Number(intervalTime) + Number(timer);
    const nextTimeMs = startDate.setMinutes(startDate.getMinutes() + temp);
    const nextTime = new Date(nextTimeMs);
    const hh = ("00" + nextTime.getHours()).slice(-2);
    const mm = ("00" + nextTime.getMinutes()).slice(-2);
    return `${hh}:${mm}`;
  };

  const createTimeLineData = (
    courseTime: number,
    startTime: string,
    intervalTime: number,
    timer: number
  ) => {
    let divisionNum = Math.ceil(
      courseTime / (Number(timer) + Number(intervalTime))
    );
    let timeLineData = [startTime];

    for (let i = 0; i < divisionNum + 6; i++) {
      let nextTime = calcNextTime(startTime, intervalTime, timer);
      timeLineData = [...timeLineData, nextTime];
      startTime = nextTime;
    }
    return timeLineData;
  };

  const handleStartTable = () => {
    isFirstRender.current = false;
    dateNow.current = Date.now();
    refCountDown.current?.start();
    const tableConfig = infoTable?.tableConfig;
    let step = infoTable?.step;
    let timeLineInfoReal = infoTable?.timeLineInfoReal;
    let stepInfos: any;
    let dateReal = infoTable?.dateReal;
    setIsRunning(true);

    if (infoTable?.status === TableSessionStatus.NotStart) {
      if (moment().isBefore(moment(infoTable?.dateReal))) {
        dateReal = moment().toISOString();
        tableConfig.startTime = moment().format("HH:mm");
        tableConfig.endTime = moment()
          .clone()
          .add(Number(tableConfig?.courseTime), "minutes")
          .format("HH:mm");
        timeLineInfoReal = createTimeLineData(
          tableConfig?.courseTime,
          tableConfig.startTime,
          tableConfig.intervalTime,
          tableConfig?.timer
        );
      } else if (moment().isAfter(moment(infoTable?.dateReal))) {
        let timeOver = moment().diff(moment(infoTable?.dateReal), "s");

        step = Math.floor(
          timeOver /
            60 /
            (Number(tableConfig?.intervalTime) + Number(tableConfig?.timer))
        );
        let timeOfStep =
          timeOver -
          step *
            (Number(tableConfig?.intervalTime) + Number(tableConfig?.timer)) *
            60;
        // if (step === 0) {
        //   timeOfStep = 0;
        // }
        stepInfos = [
          {
            time:
              (Number(tableConfig?.intervalTime) + Number(tableConfig?.timer)) *
                60 -
              timeOfStep,
            step,
            status: StepInfoStatus.Running,
          },
        ];
      }
    }
    updateTableSessionAction.mutate(
      {
        id: infoTable?._id,
        data: {
          status: TableSessionStatus.Starting,
          step,
          tableConfig,
          timeLineInfoReal,
          stepInfos,
          dateReal,
          // step: 1,
        },
      },
      {
        onSuccess: (data) => {
          // queryClient.invalidateQueries(queryKeys.listTableSession);
        },
        onError: (err) => {
          if (!!isOnline) {
            return;
          }

          let timeLineInfoReal = infoTable.timeLineInfoReal;
          let timeGap = infoTable.timeGap || 0;
          if (infoTable.status === TableSessionStatus.Stop) {
            const differTime =
              moment().diff(moment(infoTable?.lastStop), "s") + timeGap;
            timeGap = differTime % 60;
            timeLineInfoReal = timeLineInfoReal.map(
              (item: any, index: number) => {
                if (index > infoTable?.step) {
                  return moment(item, "HH:mm")
                    .add(Math.floor(differTime / 60), "m")
                    .format("HH:mm");
                }
                return item;
              }
            );
          }
          const listTableSessionCurrent = queryClient.getQueryData(
            queryKeys.listTableSession
          ) as any;
          if (Array.isArray(listTableSessionCurrent?.data)) {
            const listTableSessionNew = listTableSessionCurrent?.data?.map(
              (item: any) => {
                if (String(item?._id) === String(infoTable?._id)) {
                  return {
                    ...item,
                    timeLineInfoReal,
                    stepInfos,
                    timeGap,
                    step,
                    status: TableSessionStatus.Starting,
                  };
                }
                return item;
              }
            );
            queryClient.setQueryData(queryKeys.listTableSession, {
              data: listTableSessionNew,
            });
          }
        },
      }
    );
  };

  const handleStopTable = () => {
    setIsRunning(false);
    const timeRun = Math.floor((moment().valueOf() - dateNow.current) / 1000);
    updateTableSessionAction.mutate(
      {
        id: infoTable?._id,
        data: {
          // ..._.omit(infoTable, "_id"),
          status: TableSessionStatus.Stop,
          lastStop: moment().toISOString(),
          timeRun: countTime - timeRun,
          // step: 1,
        },
      },
      {
        onError: (err) => {
          if (!!isOnline) {
            return;
          }
          const timeRunValue = countTime - timeRun;
          let timeLineInfoReal = infoTable.timeLineInfoReal;
          let stepInfos = infoTable.stepInfos;

          if (infoTable.status === TableSessionStatus.Starting) {
            if (infoTable?.stepInfos.length === 0) {
              stepInfos.push({
                step: 0,
                time:
                  timeRunValue ||
                  (Number((infoTable?.tableConfig as any)?.timer) +
                    Number((infoTable?.tableConfig as any)?.intervalTime)) *
                    60,
                status: StepInfoStatus.Not_Run,
              });
            } else {
              stepInfos = infoTable?.stepInfos?.map((item: any) => {
                if (item?.step === infoTable?.step) {
                  return { ...item, time: timeRunValue || item?.time };
                }
                return item;
              });
            }
          }
          const listTableSessionCurrent = queryClient.getQueryData(
            queryKeys.listTableSession
          ) as any;
          if (Array.isArray(listTableSessionCurrent?.data)) {
            const listTableSessionNew = listTableSessionCurrent?.data?.map(
              (item: any) => {
                if (String(item?._id) === String(infoTable?._id)) {
                  return {
                    ...item,
                    status: TableSessionStatus.Stop,
                    lastStop: moment().toISOString(),
                  };
                }
                return item;
              }
            );
            queryClient.setQueryData(queryKeys.listTableSession, {
              data: listTableSessionNew,
            });
          }
        },
      }
    );
    lastStop.current = moment().toISOString();
    refCountDown.current?.pause();
    setCountTime(countTime - timeRun);
    dateNow.current = Date.now();
  };

  const renderer = (props: any) => (
    <p className="time">
      {overtime ? "-" : ""}
      {zeroPad(props.minutes)}:{zeroPad(props.seconds)}
    </p>
  );

  const handleSetOverTimeAutoNext = async () => {
    if (
      (defaultConfig as any)?.data?.autoNextStep === CommonStatus.ACTIVE &&
      !hasAutoNextStep.current &&
      !overtime
    ) {
      hasAutoNextStep.current = true;
      setIsAutoStepping(true);

      await setSeatingListIndex(0, true);
      setCountTime(Number(timer) * 60 + Number(intervalTime) * 60);
      setCountTimeUpdate(Number(timer) * 60 + Number(intervalTime) * 60);
      countTimeTick.current = Number(timer) * 60 + Number(intervalTime) * 60;
      dateNow.current = Date.now();

      hasAutoNextStep.current = false;
      setIsAutoStepping(false);
    } else {
      handleSetOverTime();
    }
  };

  // Thêm hàm getNow để tính toán thời gian chính xác
  const getNow = useCallback(() => {
    const timeElapsed = Date.now() - dateNow.current;
    return dateNow.current + timeElapsed;
  }, []);

  return (
    // <TakuProvider>
    <div className="timerWrapper">
      <ModalConfirm
        isVisible={showModalNextConfirm}
        title={`${infoTable?.tableConfig?.code}${infoTable?.tableConfig?.no}卓で『NEXT」が押されました。`}
        children={<>スタッフタイムテーブルを次に進めますか？</>}
        textCancel={"いいえ"}
        header="確認"
        textOke={"はい"}
        handleCancel={() => setShowModalNextConfirm(false)}
        handleClose={() => setShowModalNextConfirm(false)}
        handleOke={() => onClickNext(true)}
        closable={false}
        closeIcon={false}
      />
      <Countdown
        date={dateNow.current + countTime * 1000}
        overtime={true}
        autoStart={false}
        renderer={renderer}
        now={getNow}
        onComplete={() => {
          handleSetOverTimeAutoNext();
        }}
        onTick={() => {
          countTimeTick.current = countTimeTick.current - 1;
          if (countTimeTick.current % 5 === 0) {
            setCountTimeUpdate(countTimeTick.current);
          }
        }}
        ref={(countdown) => {
          if (countdown) {
            refCountDown.current = countdown;
          }
        }}
      />
      {Number(userPlan) !== UserPlan.SubAccount && (
        <p className="btn">
          <button onClick={() => onClickNext()}>NEXT</button>
          {isRunning ? (
            <button onClick={handleStopTable}>STOP</button>
          ) : (
            <button onClick={handleStartTable}>START</button>
          )}
        </p>
      )}
    </div>
    // </TakuProvider>
  );
}, shouldComponentUpdate);
